import { render, staticRenderFns } from "./terms_and_conditions.vue?vue&type=template&id=2f9d1709&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d1709",
  null
  
)

export default component.exports